import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { CanAvisoGuard } from './guards/can-aviso.guard';
import { CanPreregGuard } from './guards/can-prereg.guard';
import { RegistroComponent } from './components/admin/registro/registro.component';
import { HomeComponent } from './components/admin/home/home.component';
import { AvisoPrivacidadComponent } from './components/negocio/aviso-privacidad/aviso-privacidad.component';
import { RegistroUsuariosComponent } from './components/admin/registro-usuarios/registro-usuarios.component';
import { RegistroDocsarchComponent } from './components/admin/registro-docsarch/registro-docsarch.component';
import { PrincipalComponent } from './components/negocio/principal/principal.component';
import { AdquisicionesComponent } from './components/negocio/adquisiciones/adquisiciones.component';
import { RestablecerComponent } from './components/admin/restablecer/restablecer.component';
import { RestablecerContrasenaComponent } from './components/admin/restablecer-contrasena/restablecer-contrasena.component';
import { ProcedimientosComponent } from './components/negocio/procedimientos/procedimientos.component';
import { ProcedimientosDetalleComponent } from './components/negocio/procedimientos-detalle/procedimientos-detalle.component';
import { ProcsComponent } from './components/negocio/participa/procedimientos/procs.component';
import { CountDownComponent } from './components/generales/count-down/count-down.component';
import { CanRegGuard } from './guards/can-reg.guard';
import { CanDocsGuard } from './guards/can-docs.guard';
import { CanProcedGuard } from './guards/can-proced.guard';
import { CanProcedprovedGuard } from './guards/can-procedproved.guard';
import { AvisoPrivLogComponent } from './components/negocio/aviso-priv-log/aviso-priv-log.component';
import { MenuProductoComponent } from './components/negocio/participa/flujo-producto/menu-producto/menu-producto.component';
import { MenuObraComponent } from './components/negocio/participa/flujo-obra/menu-obra/menu-obra.component';
import { MenuPerfilComponent } from './components/admin/menu-perfil/menu-perfil.component';
import { CanMenuPerfilGuard } from './guards/can-menu-perfil.guard';
import { VerificarComponent } from './components/admin/verificar/verificar.component';
import { ProcedimientosDetObraComponent } from './components/negocio/procedimientos-det-obra/procedimientos-det-obra.component';
import { ReenviarCorreoComponent } from './components/admin/reenviar-correo/reenviar-correo.component';

import { PadronProveedoresComponent } from './components/negocio/padron-proveedores/padron-proveedores.component';

const routes: Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: 'home', component: HomeComponent},
  {path: 'registro/:tipo', component: RegistroComponent, canActivate: [CanPreregGuard]},
  {path: 'registro-usuarios/:id', component: RegistroUsuariosComponent, canActivate: [CanRegGuard]},
  {path: 'registro-docsarch', component: RegistroDocsarchComponent, canActivate: [CanDocsGuard]},
  {path: 'aviso-privacidad/:tipo', component: AvisoPrivacidadComponent, canActivate: [CanAvisoGuard]},
  {path: 'aviso-priv-log/:tipo', component: AvisoPrivLogComponent},
  {path: 'principal', component: PrincipalComponent},
  {path: 'adquisiciones', component: AdquisicionesComponent},
  {path: 'procedimientos', component: ProcedimientosComponent, canActivate: [CanProcedGuard]},
  {path: 'procedimientos-detalle/:anio/:idProc', component: ProcedimientosDetalleComponent, canActivate: [CanProcedGuard]},
  {path: 'procedimientos-det-obra/:anio/:idProc', component: ProcedimientosDetObraComponent, canActivate: [CanProcedGuard]},
  {path: 'procs', component: ProcsComponent, canActivate: [CanProcedprovedGuard]},
  {path: 'restablecer', component: RestablecerComponent},
  {path: 'restablecer-contrasena/:token', component: RestablecerContrasenaComponent },
  {path: 'verificar/:token/:id', component: VerificarComponent },
  {path: 'reenviar-correo', component: ReenviarCorreoComponent},
  {path: 'not-found', component: PageNotFoundComponent},
  {path: 'CountDown', component: CountDownComponent},
  {path: 'menu-producto', component: MenuProductoComponent},
  {path: 'menu-obra', component: MenuObraComponent},
  {path: 'menu-perfil', component: MenuPerfilComponent, canActivate: [CanMenuPerfilGuard]},
  {path: 'padron-proveedores', component: PadronProveedoresComponent},
  {path: '**', redirectTo: 'not-found'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})

export class AppRoutingModule {

}
